interface ITextSegment {
  text: string;
  bold: boolean;
}

const parseStrongTags = (str: string): ITextSegment[] =>
  str.split(/(<strong>.*?<\/strong>)/g).map((part) => {
    const match = part.match(/^<strong>(.*?)<\/strong>$/);
    return { text: match ? match[1] : part, bold: !!match };
  });

export default parseStrongTags;
